import { Subject } from 'rxjs';
import { EventTrackingValue } from '../../team-apis/core/event-tracking';
import { Tracker, TrackingEvent } from './event-utils';

export const eventFromBatch$ = new Subject<void>();

export class EventBatchValues {
  private context: EventTrackingValue = {};

  private maxEventDuration = 0;
  private batchDuration = 0;
  private numEvents = 0;

  private eventStart?: number;
  private batchStart?: number;
  private sumOfEventDurations?: number;

  constructor(startEvent: TrackingEvent, trackerForStartEvent: Tracker) {
    trackerForStartEvent.track({
      ...startEvent,
      id: startEvent.id + '_start',
    });
  }

  addContext(context: EventTrackingValue) {
    Object.assign(this.context, context);
  }

  /**
   * Optionally call this at the beginning of an event. Doing so will cause
   * performance timing info to be added to the final analytics event.
   */
  startEvent() {
    const now = performance.now();
    this.eventStart = now;
    this.ensureBatchStarted(now);
  }

  endEvent() {
    const now = performance.now();
    eventFromBatch$.next();
    this.ensureBatchStarted(now);
    this.batchDuration = now - this.batchStart!;
    ++this.numEvents;

    if (this.eventStart !== undefined) {
      const duration = now - this.eventStart;
      this.maxEventDuration = Math.max(this.maxEventDuration, duration);
      this.sumOfEventDurations = (this.sumOfEventDurations || 0) + duration;
      this.eventStart = undefined;
    }
  }

  buildEventTrackingValue(): EventTrackingValue {
    const value: EventTrackingValue = {
      ...this.context,
      batch_duration: this.batchDuration,
      num_events: this.numEvents,
    };
    if (this.sumOfEventDurations !== undefined) {
      value.max_event_duration = this.maxEventDuration;
      value.sum_of_event_durations = this.sumOfEventDurations;
    }
    return value;
  }

  private ensureBatchStarted(now: number) {
    if (this.batchStart === undefined) {
      this.batchStart = now;
    }
  }
}
